import {HStack} from 'platform/foundation';

import {useCallback} from 'react';

import {ColorCircle} from '@dms/shared';

import {suffixTestId, TestIdProps} from 'shared/web';

import {ApiEnumItem} from '../../../../../../../../types/ApiEnum';
import {BodyColorEnum} from './constants/BodyColorEnum';

interface ColorPickerProps extends TestIdProps {
  name?: string;
  colors?: ApiEnumItem[];
  selectedColors?: ApiEnumItem[];
  onChange?: (colors: ApiEnumItem[]) => void;
}

export function ColorPicker({
  name = 'colorPicker',
  selectedColors = [],
  onChange,
  colors = [],
  ...props
}: ColorPickerProps) {
  const handleChange = useCallback(
    (color: ApiEnumItem) => {
      const _selectedColors = [...selectedColors];
      const existingColorIndex = _selectedColors.findIndex(
        (selectedColor: ApiEnumItem) => selectedColor.key === color.key
      );

      if (existingColorIndex > -1) {
        _selectedColors.splice(existingColorIndex, 1);
      } else {
        _selectedColors.push(color);
      }

      onChange?.(_selectedColors);
    },
    [selectedColors, onChange]
  );

  return (
    <HStack wrap data-testid={suffixTestId('color-picker', props)}>
      {colors.map((color) => {
        const isSelected =
          selectedColors?.findIndex((selectedColor) => selectedColor.key === color.key) > -1;

        return (
          <ColorCircle
            data-testid={`color-picker-${name}-value-${color.key}`}
            key={color.key}
            colorLabel={color.label}
            colorCode={color.colorCode ?? undefined}
            size="large"
            isSelected={isSelected}
            needBorder={color.key === BodyColorEnum.COLOR_WHITE}
            onClick={() => handleChange(color)}
          />
        );
      })}
    </HStack>
  );
}
